<div>
  <div class="row">
    <app-dql-search-field-date class="col" [expression]="fromCriteria" [disableDelete]="true" #from></app-dql-search-field-date>
    <app-dql-search-field-date class="col" [expression]="toCriteria" [disableDelete]="true" #to></app-dql-search-field-date>
    <i class="icomoon icomoon-exit" *ngIf="!disableDelete" (click)="onDelete.emit(expression)"></i>
  </div>
</div>
